<template lang="pug">
.channel-osd.d-flex.surface-bg(
  v-nv:scope="'channel-osd'",
  @nv-ch_down="changeChannel",
  @nv-ch_up="changeChannel",
  @nv-scope-focus="focused",
  @nv-back="section()",
  @nv-numpad="$channelSelectWithNumber",
  @nv-list="section('list')"
)
  .channel-item.border-left.channel.background(
    v-nv,
    @nv-up="changeChannel",
    @nv-down="changeChannel",
    @nv-enter="changeChannel",
    @nv-focus="activeEpg = currentProgram"
  )
    .number.d-flex.flex-column.align-items-center
      i.fal.fa-chevron-up.mb-2
      .placement {{ activeChannel.placement }}
      i.fal.fa-chevron-down.mt-2
    .locked-channel.surface-bg-darker.mx-3.border(v-show="activeChannel.price && !activeChannel.owned")
      i.fas.fa-lock 
    imagec.mx-3(v-show="!activeChannel.price || activeChannel.owned", vertical, :src="activeChannel.logo", :background="false")
    .title.overflow-hidden.flex-grow-1
      pr-text(weight="bold", ellipsis) {{ activeChannel.title }}
  .channel-item.border-left.epg.background(v-nv, @nv-up="changeEpg", @nv-down="changeEpg", v-show="activeEpg")
    icon.mr-3(icon="fal sort")
    channelProgram.flex-grow-1(:data="activeEpg", :time="true", :progress="true", v-if="isEpgActive")
  .channel-seperator.flex-grow-1
  .channel-item.border-left.language.background(v-nv, @nv-enter="languages")
    icon(icon="fal audio-description")
    .container
      .small.text-muted.animated {{ $t("Language") }}
      pr-text.audio-language(ellipsis) {{ language }}
  .channel-item.border-left.subtitle.background(v-nv, @nv-enter="subtitles")
    icon(icon="fal closed-captioning")
    .container
      .small.text-muted.animated {{ $t("Subtitle") }}
      pr-text.subtitle-language(ellipsis) {{ subtitle }}
  .channel-item.border-left.favorite.background(v-nv, @nv-enter="favorite", v-show="guest && !isPrivateCategory")
    icon(:icon="activeChannel.favorite ? 'fas star' : 'fal star'", :class="{ 'text-warning': activeChannel.favorite }")
  .channel-item.border-left.record.background(v-nv, @nv-enter="saveStream", v-show="activeChannel.isRecordable && !isPrivateCategory")
    icon(icon="fal save")
</template>

<script>
import channelProgram from "./channel-program.vue"
import { mapGetters, mapState } from "vuex"
export default {
  name: "channel-osd",
  components: { channelProgram },
  data() {
    return {
      activeItem: 0,
      activeEpg: null,
      pendingAction: null
    }
  },
  computed: {
    isEpgActive() {
      return __.device.config("catchup.epg")
    },
    activeChannel() {
      return this.channels[this.activeItem] || {}
    },
    language() {
      return !this.activeChannel.language ? this.$t("Default") : this.activeChannel.language.value
    },
    subtitle() {
      return !this.activeChannel.subtitle ? this.$t("None") : this.activeChannel.subtitle.value
    },
    currentProgram() {
      return this.activeChannel?.epg?.current
    },
    ...mapState(["guest"]),
    ...mapGetters("live", ["channels", "isPrivateCategory"]),
    ...mapState("live", ["epgs", "channel"])
  },
  watch: {
    channel(nval) {
      this.goCurrent(nval)
      if (_$.nav.currentScopeName("channel-home")) this.section("osd")
    },
    channels() {
      this.goCurrent(this.channel)
    },
    activeItem() {
      this.activeEpg = this.currentProgram
    }
  },
  mounted() {
    _$.vue.$on("changeChannel", this.changeChannel)
    _$.vue.$on("osd-subtitle", this.openSubtitle)
    _$.vue.$on("osd-language", this.openLanguage)
    _$.nav.sync("channel-osd")
    if (this.channel) this.goCurrent(this.channel)
  },
  beforeDestroy() {
    _$.vue.$off("osd-subtitle", this.openSubtitle)
    _$.vue.$off("osd-language", this.openLanguage)
  },
  methods: {
    goCurrent($channel) {
      if (this.activeChannel === $channel) return

      const target = this.channels.findIndex(el => el === $channel)
      if (target >= 0) this.activeItem = target
      else this.activeItem = 0
    },
    changeChannel($e) {
      switch ($e.detail.value) {
        case "up":
          if (this.activeItem >= this.channels.length - 1) this.activeItem = 0
          else this.activeItem++

          if (__._device.numpad) return false
          if (this.timeout) this.timeout = _$.removeTimeout(this.timeout)
          if (this.channel === this.activeChannel) return

          this.timeout = _$.makeTimeout(() => {
            this.$store.commit("live/channel", this.activeChannel)
          }, 1000)
          break
        case "down":
          if (!this.activeItem) this.activeItem = this.channels.length - 1
          else this.activeItem--

          if (__._device.numpad) return false
          if (this.timeout) this.timeout = _$.removeTimeout(this.timeout)
          if (this.channel === this.activeChannel) return

          this.timeout = _$.makeTimeout(() => {
            this.$store.commit("live/channel", this.activeChannel)
          }, 1000)
          break

        case "ch_up":
          if (this.activeItem >= this.channels.length - 1) this.activeItem = 0
          else this.activeItem++

          if (this.timeout) this.timeout = _$.removeTimeout(this.timeout)
          if (this.channel === this.activeChannel) return

          this.timeout = _$.makeTimeout(
            () => {
              this.$store.commit("live/channel", this.activeChannel)
            },
            $e.detail.instant ? 0 : 1000
          )
          break
        case "ch_down":
          if (!this.activeItem) this.activeItem = this.channels.length - 1
          else this.activeItem--

          if (this.timeout) this.timeout = _$.removeTimeout(this.timeout)
          if (this.channel === this.activeChannel) return

          this.timeout = _$.makeTimeout(
            () => {
              this.$store.commit("live/channel", this.activeChannel)
            },
            $e.detail.instant ? 0 : 1000
          )
          break

        case "enter":
          if (this.channel === this.activeChannel) return this.section()
          this.$store.commit("live/channel", this.activeChannel)
          break
      }
    },
    changeEpg($e) {
      if (!this.activeEpg) return false

      const pool = this.epgs[this.activeChannel.epg_id],
        index = pool?.findIndex(item => item === this.activeEpg)

      if (index < 0) return false

      switch ($e.detail.value) {
        case "up":
          this.activeEpg = pool[index + 1] || this.activeEpg
          break
        case "down":
          this.activeEpg = pool[index - 1] || this.activeEpg
          break
      }
    },
    async subtitles($event) {
      this.goCurrent(this.channel)

      const source = __.media.getSource()
      const subtitles = await __.media.getSubtitles()
      if (!subtitles) return false

      const pid = await this.$dropdown(subtitles, $event.target)
      if (!pid || source !== __.media.getSource()) return false

      const numericPid = pid === "off" ? pid : parseInt(pid)
      const res = await __.media.setSubtitle(numericPid)

      if (res) this.channel.subtitle = subtitles.find(subtitle => subtitle.key == pid)

      return res
    },
    async languages($event) {
      this.goCurrent(this.channel)

      const source = __.media.getSource()
      const languages = await __.media.getLanguages()
      if (!languages) return false

      const pid = await this.$dropdown(languages, $event.target)
      if (!pid || source !== __.media.getSource()) return false

      const numericPid = pid === "off" ? pid : parseInt(pid)
      const res = await __.media.setLanguage(numericPid)

      if (res) this.channel.language = languages.find(language => language.key == pid)

      return res
    },
    async favorite() {
      if (this.activeChannel.favorite) __.guest.removeFavoriteChannel(this.activeChannel)
      else __.guest.addFavoriteChannel(this.activeChannel)
    },
    async saveStream() {
      let options = [
        { key: "900000", value: _$.vue.$tc("minute", 15) },
        { key: "1200000", value: _$.vue.$tc("minute", 20) },
        { key: "1800000", value: _$.vue.$tc("minute", 30) },
        { key: "2700000", value: _$.vue.$tc("minute", 45) },
        { key: "3600000", value: _$.vue.$tc("minute", 60) },
        { key: "5400000", value: _$.vue.$tc("minute", 90) },
        { key: "7200000", value: _$.vue.$tc("minute", 120) }
      ]
      let result = await _$.vue.$sidepane(
        _$.vue.$t("Record Stream"),
        _$.vue.$t("The channel will be recorded for the time you specify from now on."),
        options,
        "right"
      )
      if (!result) return false

      let recordUri = this.activeChannel.channel_uri
      if (["udp", "rtp"].some(protocol => recordUri.startsWith(protocol))) recordUri = recordUri.replace("://", "://@")

      const recordPackage = {
        id: this.activeChannel.id,
        title: this.activeChannel.title,
        start: null,
        end: null,
        duration: result / 1000,
        state: 0,
        uri: recordUri,
        proc_id: null,
        source: null,
        macAddress: __.device.get("mac"),
        ipAddress: __.device.get("ip"),
        pms_id: __.guest.get("pms_id") || "General"
      }
      __.api.set.setRecord(recordPackage)
    },
    openSubtitle() {
      this.pendingAction = "subtitles"
      if (_$.nav.currentScopeName("channel-osd")) {
        this.executePending()
      } else if (this.$store.state.routerHistory?.to?.path?.startsWith("/live")) {
        this.$emit("section", "osd")
      }
      // not on live page: pendingAction is stored, activated() → focused() will consume it
    },
    openLanguage() {
      this.pendingAction = "languages"
      if (_$.nav.currentScopeName("channel-osd")) {
        this.executePending()
      } else if (this.$store.state.routerHistory?.to?.path?.startsWith("/live")) {
        this.$emit("section", "osd")
      }
    },
    executePending() {
      if (!this.pendingAction) return
      const action = this.pendingAction
      this.pendingAction = null
      this.$nextTick(() => {
        const selector = action === "subtitles" ? ".channel-item.subtitle" : ".channel-item.language"
        const el = this.$el.querySelector(selector)
        if (el) _$.nav.move(el)
      })
    },
    focused() {
      this.goCurrent(this.channel)
      if (this.pendingAction) {
        this.executePending()
      } else {
        _$.nav.refreshScope()
      }
    },
    section(to = null) {
      this.$emit("section", to)
    }
  }
}
</script>

<style lang="scss" scoped>
.channel-osd {
  position: absolute;
  bottom: 10px;
  left: 10px;
  right: 10px;
}
.channel-item {
  display: flex;
  align-items: center;
  padding: 0 1rem;
  overflow: hidden;
  &:first-child {
    border-left: 0 !important;
  }

  &.channel,
  &.epg {
    width: 35% !important;
    flex: 0 0 auto !important;
  }

  &.language,
  &.subtitle {
    width: 10%;
  }

  &.favorite,
  &.record {
    width: 5%;
    justify-content: center;
  }

  .imagec {
    height: 100px;
  }

  .locked-channel {
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &.nv-el-current {
    .text-muted {
      color: #fff !important;
    }
  }
}
</style>
